"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function InitiateLogistics() {
  return <section data-section-id="231281" id="ready-to-evolve-your-practice" className="bg-background text-foreground border-y border-border w-full overflow-hidden bg-gradient-to-br from-primary via-secondary to-primary/90">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-[60vh] md:min-h-[70vh]">
        {}
        <div className="flex items-center justify-center p-8 md:p-16 lg:p-24 border-b md:border-b-0 md:border-r border-white/10">
          <h2 className="font-default text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold uppercase leading-[0.85] tracking-tighter w-full max-w-2xl text-white">
            Ready to<br />
            Evolve Your<br />
            Practice?
          </h2>
        </div>

        {}
        <div className="flex items-center justify-center p-8 md:p-16 lg:p-24">
          <div className="w-[80%] max-w-md md:max-w-none">
            <Button asChild variant="default" className="w-full h-auto py-12 md:py-16 lg:py-20 rounded-none bg-white text-black hover:bg-white/90 transition-transform duration-300 hover:scale-[1.03] group relative overflow-hidden shadow-2xl">
              <Link to="#">
                <span className="relative block font-default text-xl md:text-2xl lg:text-4xl font-bold uppercase tracking-widest text-center">
                  {}
                  <span className="relative z-10 block transition-all duration-75 group-hover:-translate-x-[2px] group-hover:translate-y-[2px] group-hover:skew-x-[2deg]">
                    Get Started
                  </span>
                  
                  {}
                  <span aria-hidden="true" className="absolute inset-0 z-0 block opacity-0 group-hover:opacity-70 transition-all duration-75 translate-x-[4px] -translate-y-[3px] -skew-x-[3deg] pointer-events-none text-primary">
                    Get Started
                  </span>
                  
                  {}
                  <span aria-hidden="true" className="absolute inset-0 z-0 block opacity-0 group-hover:opacity-70 transition-all duration-75 -translate-x-[4px] translate-y-[3px] skew-x-[4deg] pointer-events-none text-secondary">
                    Get Started
                  </span>
                </span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}